import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { services } from '../data/services';
import { generateMetadata } from '../modules/seo/generateMetadata';
import { ServiceSchema } from '../modules/seo/SchemaGenerator';
import { FAQSchema } from '../modules/seo/FAQSchema';
import ServiceHero from '../components/services/ServiceHero';
import ServiceFeatures from '../components/services/ServiceFeatures';
import ServicePricing from '../components/services/ServicePricing';
import ServiceFAQs from '../components/faq/ServiceFAQs';
import ContactCTA from '../components/shared/ContactCTA';

export default function ServiceDetail() {
  const { service: serviceId } = useParams();
  const service = services.find(s => s.id === serviceId);

  if (!service) {
    return <Navigate to="/services" replace />;
  }

  const metadata = generateMetadata({ service });
  const schema = ServiceSchema({
    name: service.name,
    description: service.description,
    price: { min: 499, max: 1499 }
  });

  return (
    <>
      <Helmet>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords.join(', ')} />
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>

      <ServiceHero service={service} />
      <ServiceFeatures service={service} />
      <ServicePricing service={service} />
      <ServiceFAQs serviceId={service.id} />
      <ContactCTA />
    </>
  );
}